import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import nl from "@/i18n/locales/nl.json";
import en from "@/i18n/locales/en.json";
import de from "@/i18n/locales/de.json";
import fr from "@/i18n/locales/fr.json";

export const SUPPORTED_LANGUAGES = ["nl", "en", "de", "fr"];
export const DEFAULT_LANGUAGE = "nl";
export const LANGUAGE_STORAGE_KEY = "shop_lang";

function readStoredLanguage() {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
  } catch (e) {
    /* localStorage unavailable */
  }
  return DEFAULT_LANGUAGE;
}

const initialLanguage = readStoredLanguage();

i18n.use(initReactI18next).init({
  resources: {
    nl: { translation: nl },
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: { escapeValue: false },
  returnNull: false,
});

document.documentElement.lang = initialLanguage;

export function setLanguage(lang) {
  if (!SUPPORTED_LANGUAGES.includes(lang)) return;
  i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch (e) {
    /* ignore */
  }
}

export default i18n;
